export default __webpack_public_path__ + "static/media/WutowIcon.cff1f1dc.svg";